export const COMMON_LOADER_MUTATION_TOGGLE_LOADING = 'common_loader_mutations_toggle_loading'

export const COMMON_LOADER_GETTER_IS_LOADING = 'common_loader_getter_is_loading'
